import http from '../../../../api/http';

function retrieveAllPaging(paramObj) {
    return http.post('/insights/recruitInfo/retrieveAllPaging', {
        boardGb: "RECRUIT",
        pageNumber: paramObj.pageNo,
        size: paramObj.size,
        searchType: paramObj.searchType,
        searchInput: paramObj.searchInput,
        startYmd: paramObj.startYmd,
        endYmd: paramObj.endYmd,
    })
}

function retrieveRecruitInfoDetail(boardId) {
    return http.post('/insights/recruitInfo/retrieve', {
        boardId
    })
}

function createRecruitInfo(paramObj) {
    return http.post('/insights/recruitInfo/create', {
        // boardId: 0,
        boardGb: paramObj.boardGb || "RECRUIT",
        boardGroup: paramObj.boardGroup, // "string",
        title: paramObj.title, // "string",
        content: paramObj.content, // "string",
        secretYn: paramObj.secretYn || 'N', // "string",
        notifyYn: paramObj.notifyYn || 'N',  // "string",
        answer: paramObj.answer, // "string",
        hitCount: paramObj.hitCount, // 0,
        createId: paramObj.createId, // 0,
        attachList: paramObj.attachList, // [
        //    {
        //         "attachSeq": 0,
        //         "fileName": "string",
        //         "fileSize": "string",
        //         "fileDir": "string",
        //         "deleteYn": "string"
        //     }
        // ]
    })
}

function updateRecruitInfo(paramObj) {
    return http.post('/insights/recruitInfo/update', {
        boardId: paramObj.boardId, // 0,
        boardGb: paramObj.boardGb || "RECRUIT",
        boardGroup: paramObj.boardGroup, // "string",
        title: paramObj.title, // "string",
        notifyYn: paramObj.notifyYn, // "string",
        content: paramObj.content, // "string",
        secretYn: paramObj.secretYn, // "string",
        answer: paramObj.answer, // "string",
        hitCount: paramObj.hitCount, // 0,
        createId: paramObj.createId, // 0,
        attachList: paramObj.attachList, // [
        //    {
        //         "attachSeq": 0,
        //         "fileName": "string",
        //         "fileSize": "string",
        //         "fileDir": "string",
        //         "deleteYn": "string"
        //     }
        // ]
    })
}


function deleteRecruitInfo(boardId) {
    return http.post('/insights/recruitInfo/delete', {
        boardId
    })
}

export default {
    retrieveAllPaging,
    retrieveRecruitInfoDetail,
    createRecruitInfo,
    updateRecruitInfo,
    deleteRecruitInfo,
};